import { createFileRoute } from '@tanstack/react-router'
import { CATALOG, short } from '../content'
import { Screenshot } from '../screenshot'

export const Route = createFileRoute('/products')({
  head: () => ({
    meta: [
      { title: 'products - jfrader' },
      { name: 'description', content: 'products created by jfrader.' },
      { property: 'og:title', content: 'products - jfrader' },
      { property: 'og:description', content: 'products created by jfrader.' },
      { property: 'og:url', content: 'https://jfrader.com/products' },
    ],
    links: [
      { rel: 'canonical', href: 'https://jfrader.com/products' }
    ]
  }),
  component: ProductsPage,
})

/** Inline GitHub mark (16x16, currentColor). No new deps. */
function GitHubMark() {
  return (
    <svg
      aria-hidden="true"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      style={{ verticalAlign: '-.125em', marginRight: '.3rem', flex: 'none' }}
    >
      <path
        fill="currentColor"
        d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27s1.36.09 2 .27c1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8z"
      />
    </svg>
  )
}

function ProductsPage() {
  return (
    <section className="sec">
      <h2 className="sec__label">products</h2>

      <div className="work">
        {CATALOG.map((item, index) => (
          <article className={item.img ? 'item rv' : 'item item--note rv'} key={item.name}>
            {item.img && (
              <a href={item.url} target="_blank" rel="noreferrer">
                <Screenshot image={item.img} alt={item.name} eager={index === 0} />
              </a>
            )}
            <div>
              <span className="tag">{item.tag}</span>
              <h3>{item.name}</h3>
              <p>{item.desc}</p>
              {item.stack && <div className="stack">{item.stack}</div>}
              {/* live URL, unless it is the same as the repository link below (Pocket Circuit) */}
              {item.source !== item.url && (
                <p style={{ margin: '.45rem 0 0' }}>
                  <a href={item.url} target="_blank" rel="noreferrer">
                    {short(item.url)} ↗
                  </a>
                </p>
              )}
              {/* public repository (icon + path label) */}
              {item.source && (
                <p style={{ margin: '.15rem 0 0', display: 'flex', alignItems: 'center' }}>
                  <GitHubMark />
                  <a href={item.source} target="_blank" rel="noreferrer">
                    {short(item.source)} ↗
                  </a>
                </p>
              )}
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}
